import React, { Fragment, useCallback, useEffect, useState } from "react";
import { Nav, Dropdown } from "react-bootstrap";
import Noti from "../../assets/img/more.png";
import { useNavigate } from "react-router-dom";
import Pagination from "../Pagination/Pagination";
import { fetchgetAllprospect } from "../../redux/Slices/getProspect";
import { useDispatch } from "react-redux";
import { RiDeleteBin3Line } from "react-icons/ri";

export default function ProspectTable({ tableData }) {
  const [page, setpage] = useState(1);
  const [TotalPages, setTotalPages] = useState(1);
  const [postsPerPage, setpostsPerPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPost, settotalPost] = useState(tableData.totalCount);

  const [size, setsize] = useState(50);

  // const [totalPost, settotalPost] = useState(getCustomer.totalCount);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const NavigationToProfileUpdate = async (id) => {
    try {
      navigate(`/prospect/view/${id}`);
    } catch (err) {
      console.log(err);
    }
  };
  const paginate = (page) => setpage(page);
  useEffect(() => {
    setTotalPages(tableData?.totalPages);
    setpostsPerPage(tableData?.pageSize);
    settotalPost(tableData?.totalCount);
  }, [tableData]);
  console.log(tableData, "<===============tabdata");
  useEffect(() => {
    dispatch(fetchgetAllprospect({ page, size }));
  }, [dispatch, page, size]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);

  const handleScroll = useCallback(() => {
    if (
      window.innerHeight + document.documentElement.scrollTop ===
      document.documentElement.offsetHeight
    ) {
      if (totalPost > size) {
        setsize((prevSize) => prevSize + 40);
      }
    }
  }, [size, totalPost]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll, size]);
  return (
    <Fragment>
      <div className="routedashboard mainpage customertable equipmentTable">
        <div className="ct-chart" id="chartActivity">
          <table>
            <thead>
              <tr>
                <th>Customer Name</th>
                <th>Prospect Type</th>
                <th>Is Converted</th>
                <th>Type</th>
                <th>Address</th>
                <th>Mobile No</th>
                <th>Email</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {tableData?.items?.map((item, i) => (
                <tr key={i} className="prospectlist">
                  <td onClick={() => NavigationToProfileUpdate(item?._id)}>
                    {item?.first_name + " " + item?.last_name}
                  </td>
                  <td onClick={() => NavigationToProfileUpdate(item?._id)}>
                    {item?.ProspectType ? "Work Order" : "Service"}
                  </td>{" "}
                  <td onClick={() => NavigationToProfileUpdate(item?._id)}>
                    {item?.ProspectConverted ? "Yes" : "No"}
                  </td>{" "}
                  <td onClick={() => NavigationToProfileUpdate(item?._id)}>
                    {item?.ProspectWaterBodyType}
                  </td>{" "}
                  <td onClick={() => NavigationToProfileUpdate(item?._id)}>
                    {item?.billing_address}
                  </td>
                  <td onClick={() => NavigationToProfileUpdate(item?._id)}>
                    {item?.mobile_no_primary}
                  </td>
                  <td onClick={() => NavigationToProfileUpdate(item?._id)}>
                    {item?.email}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Fragment>
  );
}
